/**
 * File: SignUpPage.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.2.1
 * Created: 2025-07-23
 * Last Updated: 2026-06-22
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { useNavigate } from "react-router-dom";
import { useState } from "react";

// Local project files
import { TextButton } from "../components/ui/Buttons";
import { routes } from "../constants/routes";
import { signUp } from "../utils/ServiceRequests";
import AuthPrompt from "../components/forms/AuthPrompt";
import EmailField from "../components/forms/EmailField";
import FormHeader from "../components/forms/FormHeader";
import Logo from "../components/ui/Logo";
import PasswordField from "../components/forms/PasswordField";
import TextField from "../components/forms/TextField";

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function SignUpPage({ schema, setIsUserAuth }) {
    const redirect = useNavigate();

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await signUp(firstName, lastName, email, password);
            setIsUserAuth(true);
            redirect(routes.user.dashboard.abs);
        } catch (error) {
            alert(error.message);
        }
    };

    return (
        <>
            <article className="auth__article">
                <form className="auth__form" onSubmit={handleSubmit}>
                    <Logo isLink={true} />
                    <FormHeader {...schema.formHeader} />
                    <fieldset>
                        <div className="sign-up__container">
                            <TextField
                                label={"First Name"}
                                text={firstName}
                                setText={setFirstName}
                            />
                            <TextField
                                label={"Last Name"}
                                text={lastName}
                                setText={setLastName}
                            />
                        </div>
                        <EmailField email={email} setEmail={setEmail} />
                        <PasswordField
                            label={"Password"}
                            id={"password-sign-up"}
                            placeholder={"Password"}
                            password={password}
                            setPassword={setPassword}
                            isValidationHint={true}
                        />
                    </fieldset>
                    <TextButton {...schema.textButton}></TextButton>
                    <hr></hr>
                    <AuthPrompt {...schema.authPrompt} />
                </form>
            </article>
        </>
    );
}

export default SignUpPage;
